module.exports = __webpack_public_path__ + "static/media/mtr_coordinates.081117c0.geojson";